import MaintenanceService from '../services/maintenance.service';

export const maintenance = {
  state: {
    activations: [],
    bankAccountTypes: [],
    offices: [],
    nmiRebate: [],
    bankBranches: [],
    banks: [],
    bondInvestmentTypes: [],
    callAccountTypes: [],
    countries: [],
    cities: [],
    clientTypes: [],
    currencies: [],
    dealerGroups: [],
    deliveryMethods: [],
    depositMethods: [],
    financialYears: [],
    frequencies: [],
    holidays: [],
    identityTypes: [],
    overrideReasons: [],
    propertyTypes: [],
    rejectionReasons: [],
    sectors: [],
    accountStatuses: [],
    custodianStatuses: [],
    propertyStatuses: [],
    exchangePairs: [],
    titles: [],
    transactionCodes: [],
  },

//********************************************************************GETTERS*****************************************************************************************
//********************************************************************************************************************************************************************

  getters: {
    allActivations: (state) => state.activations,
    unconfirmedActivations: (state) => {return [state.activations.filter(a => a.CheckerID == 0),[state.activations.title = "Activations"]]},
    allBankAccountTypes: (state) => state.bankAccountTypes,
    unconfirmedBankAccountTypes: (state) => {return [state.bankAccountTypes.filter(b => b.CheckerID == 0),[state.bankAccountTypes.title = "Bank Account Types"]]},
    allOffices: (state) => state.offices,
    unconfirmedOffices: (state) => {return [state.offices.filter(o => o.CheckerID == 0),[state.offices.title = "Offices"]]},
    allNMIRebates: (state) => state.nmiRebate,
    unconfirmedNMIRebates: (state) => {return [state.nmiRebate.filter(o => o.CheckerID == 0),[state.nmiRebate.title = "NMI Rebate Rates"]]},
    allBankBranches: (state) => state.bankBranches,
    unconfirmedBankBranches: (state) => {return [state.bankBranches.filter(b => b.CheckerID == 0),[state.bankBranches.title = "Bank Branches"]]},
    allBanks: (state) => state.banks,
    unconfirmedBanks: (state) => {return [state.banks.filter(b => b.CheckerID == 0),[state.banks.title = "Banks"]]},
    allBondInvestmentTypes: (state) => state.bondInvestmentTypes,
    unconfirmedBondInvestmentTypes: (state) => {return [state.bondInvestmentTypes.filter(b => b.CheckerID == 0),[state.bondInvestmentTypes.title = "Bond Investment Types"]]},
    allCallAccountTypes: (state) => state.callAccountTypes,
    unconfirmedCallAccountTypes: (state) => {return [state.callAccountTypes.filter(c => c.CheckerID == 0),[state.callAccountTypes.title = "Call Account Types"]]},
    allCountries: (state) => state.countries,
    unconfirmedCountries: (state) => {return [state.countries.filter(c => c.CheckerID == 0),[state.countries.title = "Countries"]]},
    allCities: (state) => state.cities,
    unconfirmedCities: (state) => {return [state.cities.filter(c => c.CheckerID == 0),[state.cities.title = "Cities"]]},
    allClientTypes: (state) => state.clientTypes,
    unconfirmedClientTypes: (state) => {return [state.clientTypes.filter(c => c.CheckerID == 0),[state.clientTypes.title = "Client Types"]]},
    allCurrencies: (state) => state.currencies,
    unconfirmedCurrencies: (state) => {return [state.currencies.filter(c => c.CheckerID == 0),[state.currencies.title = "Currencies"]]},
    allDealerGroups: (state) => state.dealerGroups,
    unconfirmedDealerGroups: (state) => {return [state.dealerGroups.filter(d => d.CheckerID == 0),[state.dealerGroups.title = "Dealer Groups"]]},
    allDeliveryMethods: (state) => state.deliveryMethods,
    unconfirmedDeliveryMethods: (state) => {return [state.deliveryMethods.filter(d => d.CheckerID == 0),[state.deliveryMethods.title = "Delivery Methods"]]},
    allDepositMethods: (state) => state.depositMethods,
    unconfirmedDepositMethods: (state) => {return [state.depositMethods.filter(d => d.CheckerID == 0),[state.depositMethods.title = "Deposit Methods"]]},
    allFinancialYears: (state) => state.financialYears,
    unconfirmedFinancialYears: (state) => {return [state.financialYears.filter(f => f.CheckerID == 0),[state.financialYears.title = "Financial Years"]]},
    allFrequencies: (state) => state.frequencies,
    unconfirmedFrequencies: (state) => {return [state.frequencies.filter(f => f.CheckerID == 0),[state.frequencies.title = "Frequencies"]]},
    allHolidays: (state) => state.holidays,
    unconfirmedHolidays: (state) => {return [state.holidays.filter(h => h.CheckerID == 0),[state.holidays.title = "Holidays"]]},
    allIdentityTypes: (state) => state.identityTypes,
    unconfirmedIdentityTypes: (state) => {return [state.identityTypes.filter(i => i.CheckerID == 0),[state.identityTypes.title = "Identity Types"]]},
    allOverrideReasons: (state) => state.overrideReasons,
    unconfirmedOverrideReasons: (state) => {return [state.overrideReasons.filter(o => o.CheckerID == 0),[state.overrideReasons.title = "Override Reasons"]]},
    allPropertyTypes: (state) => state.propertyTypes,
    unconfirmedPropertyTypes: (state) => {return [state.propertyTypes.filter(p => p.CheckerID == 0),[state.propertyTypes.title = "Property Types"]]},
    allRejectionReasons: (state) => state.rejectionReasons,
    unconfirmedRejectionReasons: (state) => {return [state.rejectionReasons.filter(r => r.CheckerID == 0),[state.rejectionReasons.title = "Rejection Reasons"]]},
    allSectors: (state) => state.sectors,
    unconfirmedSectors: (state) => {return [state.sectors.filter(s => s.CheckerID == 0),[state.sectors.title = "Sectors"]]},
    allAccountStatuses: (state) => state.accountStatuses,
    unconfirmedAccountStatuses: (state) => {return [state.accountStatuses.filter(a => a.CheckerID == 0),[state.accountStatuses.title = "Account Statuses"]]},
    allCustodianStatuses: (state) => state.custodianStatuses,
    unconfirmedCustodianStatuses: (state) => {return [state.custodianStatuses.filter(c => c.CheckerID == 0),[state.custodianStatuses.title = "Custodian Statuses"]]},
    allPropertyStatuses: (state) => state.propertyStatuses,
    unconfirmedPropertyStatuses: (state) => {return [state.propertyStatuses.filter(p => p.CheckerID == 0),[state.propertyStatuses.title = "Property Statuses"]]},
    allExchangePairs: (state) => state.exchangePairs,
    unconfirmedExchangePairs: (state) => {return [state.exchangePairs.filter(e => e.CheckerID == 0),[state.exchangePairs.title = "Exchange Pairs"]]},
    allTitles: (state) => state.titles,
    unconfirmedTitles: (state) => {return [state.titles.filter(t => t.CheckerID == 0),[state.titles.title = "Titles"]]},
    allTransactionCodes: (state) => state.transactionCodes,
    unconfirmedTransactionCodes: (state) => {return [state.transactionCodes.filter(t => t.CheckerID == 0),[state.transactionCodes.title = "Transaction Codes"]]},
  },

//********************************************************************ACTIONS*****************************************************************************************
//********************************************************************************************************************************************************************

  actions: {
    createActivation( {commit}, data) {
      return MaintenanceService.createActivation(data).then(
        response => {
          commit('newActivation', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllActivations({ commit }) {
      return MaintenanceService.getAllActivations().then(
        response => {
          commit('setActivations', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateActivation({ commit }, data) {
      return MaintenanceService.updateActivation(data.ActivationID, data).then(
        response => {
          commit('updActivation', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteActivation({ commit }, data) {
      return MaintenanceService.deleteActivation(data.ActivationID).then(
        response => {
          commit('dltActivation', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BANK ACCOUNT TYPES

  createBankAccountType( {commit}, data) {
      return MaintenanceService.createBankAccountType(data).then(
        response => {
          commit('newBankAccountType', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllBankAccountTypes({ commit }) {
      return MaintenanceService.getAllBankAccountTypes().then(
        response => {
          commit('setBankAccountTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateBankAccountType({ commit }, data) {
      return MaintenanceService.updateBankAccountType(data.BankAccountTypeID, data).then(
        response => {
          commit('updBankAccountType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteBankAccountType({ commit }, data) {
      return MaintenanceService.deleteBankAccountType(data.BankAccountTypeID).then(
        response => {
          commit('dltBankAccountType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // OFFICES

  createOffice( {commit}, data) {
      return MaintenanceService.createOffice(data).then(
        response => {
          commit('newOffice', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllOffices({ commit }) {
      return MaintenanceService.getAllOffices().then(
        response => {
          commit('setOffices', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateOffice({ commit }, data) {
      return MaintenanceService.updateOffice(data.OfficeId, data).then(
        response => {
          commit('updOffice', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteOffice({ commit }, data) {
      return MaintenanceService.deleteOffice(data.OfficeId).then(
        response => {
          commit('dltOffice', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // NMI REBATES

  createNMIRebate( {commit}, data) {
      return MaintenanceService.createNMIRebate(data).then(
        response => {
          commit('newNMIRebate', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllNMIRebates({ commit }) {
      return MaintenanceService.getAllNMIRebates().then(
        response => {
          commit('setNMIRebates', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateNMIRebate({ commit }, data) {
      return MaintenanceService.updateNMIRebate(data.NMIRebateRateID, data).then(
        response => {
          commit('updNMIRebate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteNMIRebate({ commit }, data) {
      return MaintenanceService.deleteNMIRebate(data.NMIRebateRateID).then(
        response => {
          commit('dltNMIRebate', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BANK BRANCHES

  createBankBranch( {commit}, data) {
      return MaintenanceService.createBankBranch(data).then(
        response => {
          commit('newBankBranch', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllBankBranches({ commit }) {
      return MaintenanceService.getAllBankBranches().then(
        response => {
          commit('setBankBranches', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateBankBranch({ commit }, data) {
      return MaintenanceService.updateBankBranch(data.BranchID, data).then(
        response => {
          commit('updBankBranch', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteBankBranch({ commit }, data) {
      return MaintenanceService.deleteBankBranch(data.BranchID).then(
        response => {
          commit('dltBankBranch', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BANKS

  createBank( {commit}, data) {
      return MaintenanceService.createBank(data).then(
        response => {
          commit('newBank', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllBanks({ commit }) {
      return MaintenanceService.getAllBanks().then(
        response => {
          commit('setBanks', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateBank({ commit }, data) {
      return MaintenanceService.updateBank(data.BankID, data).then(
        response => {
          commit('updBank', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteBank({ commit }, data) {
      return MaintenanceService.deleteBank(data.BankID).then(
        response => {
          commit('dltBank', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BOND INVESTMENT TYPES

  createBondInvestmentType( {commit}, data) {
      return MaintenanceService.createBondInvestmentType(data).then(
        response => {
          commit('newBondInvestmentType', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllBondInvestmentTypes({ commit }) {
      return MaintenanceService.getAllBondInvestmentTypes().then(
        response => {
          commit('setBondInvestmentTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateBondInvestmentType({ commit }, data) {
      return MaintenanceService.updateBondInvestmentType(data.BondInvestmentTypeID, data).then(
        response => {
          commit('updBondInvestmentType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteBondInvestmentType({ commit }, data) {
      return MaintenanceService.deleteBondInvestmentType(data.BondInvestmentTypeID).then(
        response => {
          commit('dltBondInvestmentType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CALL ACCOUNT TYPES

  createCallAccountType( {commit}, data) {
      return MaintenanceService.createCallAccountType(data).then(
        response => {
          commit('newCallAccountType', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCallAccountTypes({ commit }) {
      return MaintenanceService.getAllCallAccountTypes().then(
        response => {
          commit('setCallAccountTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCallAccountType({ commit }, data) {
      return MaintenanceService.updateCallAccountType(data.CallAccountTypeID, data).then(
        response => {
          commit('updCallAccountType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCallAccountType({ commit }, data) {
      return MaintenanceService.deleteCallAccountType(data.CallAccountTypeID).then(
        response => {
          commit('dltCallAccountType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // COUNTRIES

  createCountry( {commit}, data) {
      return MaintenanceService.createCountry(data).then(
        response => {
          commit('newCountry', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCountries({ commit }) {
      return MaintenanceService.getAllCountries().then(
        response => {
          commit('setCountries', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCountry({ commit }, data) {
      return MaintenanceService.updateCountry(data.CountryId, data).then(
        response => {
          commit('updCountry', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCountry({ commit }, data) {
      return MaintenanceService.deleteCountry(data.CountryId).then(
        response => {
          commit('dltCountry', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CITIES

  createCity( {commit}, data) {
      return MaintenanceService.createCity(data).then(
        response => {
          commit('newCity', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCities({ commit }) {
      return MaintenanceService.getAllCities().then(
        response => {
          commit('setCities', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCity({ commit }, data) {
      return MaintenanceService.updateCity(data.CityID, data).then(
        response => {
          commit('updCity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCity({ commit }, data) {
      return MaintenanceService.deleteCity(data.CityID).then(
        response => {
          commit('dltCity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CLIENT TYPES

  createClientType( {commit}, data) {
      return MaintenanceService.createClientType(data).then(
        response => {
          commit('newClientType', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllClientTypes({ commit }) {
      return MaintenanceService.getAllClientTypes().then(
        response => {
          commit('setClientTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateClientType({ commit }, data) {
      return MaintenanceService.updateClientType(data.ClientTypeID, data).then(
        response => {
          commit('updClientType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteClientType({ commit }, data) {
      return MaintenanceService.deleteClientType(data.ClientTypeID).then(
        response => {
          commit('dltClientType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CURRENCIES

  createCurrency( {commit}, data) {
      return MaintenanceService.createCurrency(data).then(
        response => {
          commit('newCurrency', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCurrencies({ commit }) {
      return MaintenanceService.getAllCurrencies().then(
        response => {
          commit('setCurrencies', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCurrency({ commit }, data) {
      return MaintenanceService.updateCurrency(data.CurrencyID, data).then(
        response => {
          commit('updCurrency', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCurrency({ commit }, data) {
      return MaintenanceService.deleteCurrency(data.CurrencyID).then(
        response => {
          commit('dltCurrency', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // DEALER GROUPS

  createDealerGroup( {commit}, data) {
      return MaintenanceService.createDealerGroup(data).then(
        response => {
          commit('newDealerGroup', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllDealerGroups({ commit }) {
      return MaintenanceService.getAllDealerGroups().then(
        response => {
          commit('setDealerGroups', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateDealerGroup({ commit }, data) {
      return MaintenanceService.updateDealerGroup(data.DealerGroupID, data).then(
        response => {
          commit('updDealerGroup', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteDealerGroup({ commit }, data) {
      return MaintenanceService.deleteDealerGroup(data.DealerGroupID).then(
        response => {
          commit('dltDealerGroup', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // DELIVERY METHODS

  createDeliveryMethod( {commit}, data) {
      return MaintenanceService.createDeliveryMethod(data).then(
        response => {
          commit('newDeliveryMethod', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllDeliveryMethods({ commit }) {
      return MaintenanceService.getAllDeliveryMethods().then(
        response => {
          commit('setDeliveryMethods', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateDeliveryMethod({ commit }, data) {
      return MaintenanceService.updateDeliveryMethod(data.DeliveryMethodID, data).then(
        response => {
          commit('updDeliveryMethod', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteDeliveryMethod({ commit }, data) {
      return MaintenanceService.deleteDeliveryMethod(data.DeliveryMethodID).then(
        response => {
          commit('dltDeliveryMethod', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // DEPOSIT METHODS

  createDepositMethod( {commit}, data) {
      return MaintenanceService.createDepositMethod(data).then(
        response => {
          commit('newDepositMethod', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllDepositMethods({ commit }) {
      return MaintenanceService.getAllDepositMethods().then(
        response => {
          commit('setDepositMethods', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateDepositMethod({ commit }, data) {
      return MaintenanceService.updateDepositMethod(data.DepositMethodID, data).then(
        response => {
          commit('updDepositMethod', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteDepositMethod({ commit }, data) {
      return MaintenanceService.deleteDepositMethod(data.DepositMethodID).then(
        response => {
          commit('dltDepositMethod', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // FINANCIAL YEARS

  createFinancialYear( {commit}, data) {
      return MaintenanceService.createFinancialYear(data).then(
        response => {
          commit('newFinancialYear', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllFinancialYears({ commit }) {
      return MaintenanceService.getAllFinancialYears().then(
        response => {
          commit('setFinancialYears', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateFinancialYear({ commit }, data) {
      return MaintenanceService.updateFinancialYear(data.FinancialYearID, data).then(
        response => {
          commit('updFinancialYear', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteFinancialYear({ commit }, data) {
      return MaintenanceService.deleteFinancialYear(data.FinancialYearID).then(
        response => {
          commit('dltFinancialYear', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // FREQUENCIES

  createFrequency( {commit}, data) {
      return MaintenanceService.createFrequency(data).then(
        response => {
          commit('newFrequency', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllFrequencies({ commit }) {
      return MaintenanceService.getAllFrequencies().then(
        response => {
          commit('setFrequencies', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateFrequency({ commit }, data) {
      return MaintenanceService.updateFrequency(data.FrequencyID, data).then(
        response => {
          commit('updFrequency', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteFrequency({ commit }, data) {
      return MaintenanceService.deleteFrequency(data.FrequencyID).then(
        response => {
          commit('dltFrequency', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // HOLIDAYS

  createHoliday( {commit}, data) {
      return MaintenanceService.createHoliday(data).then(
        response => {
          commit('newHoliday', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllHolidays({ commit }) {
      return MaintenanceService.getAllHolidays().then(
        response => {
          commit('setHolidays', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateHoliday({ commit }, data) {
      return MaintenanceService.updateHoliday(data.HolidayID, data).then(
        response => {
          commit('updHoliday', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteHoliday({ commit }, data) {
      return MaintenanceService.deleteHoliday(data.HolidayID).then(
        response => {
          commit('dltHoliday', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // IDENTITY TYPES

  createIdentityType( {commit}, data) {
      return MaintenanceService.createIdentityType(data).then(
        response => {
          commit('newIdentityType', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllIdentityTypes({ commit }) {
      return MaintenanceService.getAllIdentityTypes().then(
        response => {
          commit('setIdentityTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateIdentityType({ commit }, data) {
      return MaintenanceService.updateIdentityType(data.IdentityTypeID, data).then(
        response => {
          commit('updIdentityType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteIdentityType({ commit }, data) {
      return MaintenanceService.deleteIdentityType(data.IdentityTypeID).then(
        response => {
          commit('dltIdentityType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // OVERRIDE REASONS

  createOverrideReason( {commit}, data) {
      return MaintenanceService.createOverrideReason(data).then(
        response => {
          commit('newOverrideReason', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllOverrideReasons({ commit }) {
      return MaintenanceService.getAllOverrideReasons().then(
        response => {
          commit('setOverrideReasons', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateOverrideReason({ commit }, data) {
      return MaintenanceService.updateOverrideReason(data.OverrideReasonID, data).then(
        response => {
          commit('updOverrideReason', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteOverrideReason({ commit }, data) {
      return MaintenanceService.deleteOverrideReason(data.OverrideReasonID).then(
        response => {
          commit('dltOverrideReason', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // PROPERTY TYPES

  createPropertyType( {commit}, data) {
      return MaintenanceService.createPropertyType(data).then(
        response => {
          commit('newPropertyType', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllPropertyTypes({ commit }) {
      return MaintenanceService.getAllPropertyTypes().then(
        response => {
          commit('setPropertyTypes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updatePropertyType({ commit }, data) {
      return MaintenanceService.updatePropertyType(data.PropertyTypeID, data).then(
        response => {
          commit('updPropertyType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deletePropertyType({ commit }, data) {
      return MaintenanceService.deletePropertyType(data.PropertyTypeID).then(
        response => {
          commit('dltPropertyType', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // REJECTION REASONS

  createRejectionReason( {commit}, data) {
      return MaintenanceService.createRejectionReason(data).then(
        response => {
          commit('newRejectionReason', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllRejectionReasons({ commit }) {
      return MaintenanceService.getAllRejectionReasons().then(
        response => {
          commit('setRejectionReasons', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateRejectionReason({ commit }, data) {
      return MaintenanceService.updateRejectionReason(data.RejectionReasonID, data).then(
        response => {
          commit('updRejectionReason', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteRejectionReason({ commit }, data) {
      return MaintenanceService.deleteRejectionReason(data.RejectionReasonID).then(
        response => {
          commit('dltRejectionReason', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SECTORS

  createSector( {commit}, data) {
      return MaintenanceService.createSector(data).then(
        response => {
          commit('newSector', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllSectors({ commit }) {
      return MaintenanceService.getAllSectors().then(
        response => {
          commit('setSectors', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateSector({ commit }, data) {
      return MaintenanceService.updateSector(data.SectorID, data).then(
        response => {
          commit('updSector', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteSector({ commit }, data) {
      return MaintenanceService.deleteSector(data.SectorID).then(
        response => {
          commit('dltSector', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ACCOUNT STATUSES

  createAccountStatus( {commit}, data) {
      return MaintenanceService.createAccountStatus(data).then(
        response => {
          commit('newAccountStatus', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllAccountStatuses({ commit }) {
      return MaintenanceService.getAllAccountStatuses().then(
        response => {
          commit('setAccountStatuses', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateAccountStatus({ commit }, data) {
      return MaintenanceService.updateAccountStatus(data.AccountStatusID, data).then(
        response => {
          commit('updAccountStatus', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteAccountStatus({ commit }, data) {
      return MaintenanceService.deleteAccountStatus(data.AccountStatusID).then(
        response => {
          commit('dltAccountStatus', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CUSTODIAN STATUSES

  createCustodianStatus( {commit}, data) {
      return MaintenanceService.createCustodianStatus(data).then(
        response => {
          commit('newCustodianStatus', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllCustodianStatuses({ commit }) {
      return MaintenanceService.getAllCustodianStatuses().then(
        response => {
          commit('setCustodianStatuses', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateCustodianStatus({ commit }, data) {
      return MaintenanceService.updateCustodianStatus(data.CustodianStatusID, data).then(
        response => {
          commit('updCustodianStatus', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteCustodianStatus({ commit }, data) {
      return MaintenanceService.deleteCustodianStatus(data.CustodianStatusID).then(
        response => {
          commit('dltCustodianStatus', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // PROPERTY STATUSES

  createPropertyStatus( {commit}, data) {
      return MaintenanceService.createPropertyStatus(data).then(
        response => {
          commit('newPropertyStatus', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllPropertyStatuses({ commit }) {
      return MaintenanceService.getAllPropertyStatuses().then(
        response => {
          commit('setPropertyStatuses', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updatePropertyStatuses({ commit }, data) {
      return MaintenanceService.updatePropertyStatus(data.PropertyStatusID, data).then(
        response => {
          commit('updPropertyStatus', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deletePropertyStatus({ commit }, data) {
      return MaintenanceService.deletePropertyStatus(data.PropertyStatusID).then(
        response => {
          commit('dltPropertyStatus', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // EXCHANGE PAIRS

  createExchangePair( {commit}, data) {
      return MaintenanceService.createExchangePair(data).then(
        response => {
          commit('newExchangePair', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllExchangePairs({ commit }) {
      return MaintenanceService.getAllExchangePairs().then(
        response => {
          commit('setExchangePairs', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateExchangePair({ commit }, data) {
      return MaintenanceService.updateExchangePair(data.ExchangeID, data).then(
        response => {
          commit('updExchangePair', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteExchangePair({ commit }, data) {
      return MaintenanceService.deleteExchangePair(data.ExchangeID).then(
        response => {
          commit('dltExchangePair', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // TITLES

  createTitle( {commit}, data) {
      return MaintenanceService.createTitle(data).then(
        response => {
          commit('newTitle', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllTitles({ commit }) {
      return MaintenanceService.getAllTitles().then(
        response => {
          commit('setTitles', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateTitle({ commit }, data) {
      return MaintenanceService.updateTitle(data.TitleID, data).then(
        response => {
          commit('updTitle', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteTitle({ commit }, data) {
      return MaintenanceService.deleteTitle(data.TitleID).then(
        response => {
          commit('dltTitle', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // TRANSACTION CODES

  createTransactionCode( {commit}, data) {
      return MaintenanceService.createTransactionCode(data).then(
        response => {
          commit('newTransactionCode', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllTransactionCodes({ commit }) {
      return MaintenanceService.getAllTransactionCodes().then(
        response => {
          commit('setTransactionCodes', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateTransactionCode({ commit }, data) {
      return MaintenanceService.updateTransactionCode(data.TransactionCodeID, data).then(
        response => {
          commit('updTransactionCode', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteTransactionCode({ commit }, data) {
      return MaintenanceService.deleteTransactionCode(data.TransactionCodeID).then(
        response => {
          commit('dltTransactionCode', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
  },

//********************************************************************MUTATIONS***************************************************************************************
//********************************************************************************************************************************************************************

  mutations: {
    newActivation: (state, activation) => state.activations.unshift(activation.data),
    setActivations: (state, activations) => (state.activations = activations),
    updActivation: (state, updatedActivation) => {
      const index = state.activations.findIndex(activations => activations.ActivationID === updatedActivation.ActivationID);
      if (index !== -1) {
        state.activations.splice(index, 1, updatedActivation);
      }
    },
    dltActivation: (state, Activation) => {
      const index = state.activations.findIndex(activations => activations.ActivationID === Activation.ActivationID);
      if (index !== -1) {
        state.activations.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BANK ACCOUNT TYPES

    newBankAccountType: (state, bankAccountType) => state.bankAccountTypes.unshift(bankAccountType.data),
    setBankAccountTypes: (state, bankAccountTypes) => (state.bankAccountTypes = bankAccountTypes),
    updBankAccountType: (state, updatedBankAccountType) => {
      const index = state.bankAccountTypes.findIndex(bankAccountTypes => bankAccountTypes.BankAccountTypeID === updatedBankAccountType.BankAccountTypeID);
      if (index !== -1) {
        state.bankAccountTypes.splice(index, 1, updatedBankAccountType);
      }
    },
    dltBankAccountType: (state, BankAccountType) => {
      const index = state.bankAccountTypes.findIndex(bankAccountTypes => bankAccountTypes.BankAccountTypeID === BankAccountType.BankAccountTypeID);
      if (index !== -1) {
        state.bankAccountTypes.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // OFFICES

    newOffice: (state, office) => state.offices.unshift(office.data),
    setOffices: (state, offices) => (state.offices = offices),
    updOffice: (state, updatedOffice) => {
      const index = state.offices.findIndex(offices => offices.OfficeId === updatedOffice.OfficeId);
      if (index !== -1) {
        state.offices.splice(index, 1, updatedOffice);
      }
    },
    dltOffice: (state, Office) => {
      const index = state.offices.findIndex(offices => offices.OfficeId === Office.OfficeId);
      if (index !== -1) {
        state.offices.splice(index, 1);
      }
    },

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // NMI REBATES

    newNMIRebate: (state, rebate) => state.nmiRebate.unshift(rebate.data),
    setNMIRebates: (state, rebates) => (state.nmiRebate = rebates),
    updNMIRebate: (state, updatedRebate) => {
      const index = state.nmiRebate.findIndex(o => o.NMIRebateRateID === updatedRebate.NMIRebateRateID);
      if (index !== -1) {
        state.nmiRebate.splice(index, 1, updatedRebate);
      }
    },
    dltNMIRebate: (state, Rebate) => {
      const index = state.nmiRebate.findIndex(o => o.NMIRebateRateID === Rebate.NMIRebateRateID);
      if (index !== -1) {
        state.nmiRebate.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BANK BRANCHES

    newBankBranch: (state, branch) => state.bankBranches.unshift(branch.data),
    setBankBranches: (state, branches) => (state.bankBranches = branches),
    updBankBranch: (state, updatedBranch) => {
      const index = state.bankBranches.findIndex(b => b.BranchID === updatedBranch.BranchID);
      if (index !== -1) {
        state.bankBranches.splice(index, 1, updatedBranch);
      }
    },
    dltBankBranch: (state, Branch) => {
      const index = state.bankBranches.findIndex(b => b.BranchID === Branch.BranchID);
      if (index !== -1) {
        state.bankBranches.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BANKS

    newBank: (state, bank) => state.banks.unshift(bank.data),
    setBanks: (state, banks) => (state.banks = banks),
    updBank: (state, updatedBank) => {
      const index = state.banks.findIndex(banks => banks.BankID === updatedBank.BankID);
      if (index !== -1) {
        state.banks.splice(index, 1, updatedBank);
      }
    },
    dltBank: (state, Bank) => {
      const index = state.banks.findIndex(banks => banks.BankID === Bank.BankID);
      if (index !== -1) {
        state.banks.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BOND INVESTMENT TYPES

    newBondInvestmentType: (state, bondInvestmentType) => state.bondInvestmentTypes.unshift(bondInvestmentType.data),
    setBondInvestmentTypes: (state, bondInvestmentTypes) => (state.bondInvestmentTypes = bondInvestmentTypes),
    updBondInvestmentType: (state, updatedBondInvestmentType) => {
      const index = state.bondInvestmentTypes.findIndex(bondInvestmentTypes => bondInvestmentTypes.BondInvestmentTypeID === updatedBondInvestmentType.BondInvestmentTypeID);
      if (index !== -1) {
        state.bondInvestmentTypes.splice(index, 1, updatedBondInvestmentType);
      }
    },
    dltBondInvestmentType: (state, BondInvestmentType) => {
      const index = state.bondInvestmentTypes.findIndex(bondInvestmentTypes => bondInvestmentTypes.BondInvestmentTypeID === BondInvestmentType.BondInvestmentTypeID);
      if (index !== -1) {
        state.bondInvestmentTypes.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CALL ACCOUNT TYPES

    newCallAccountType: (state, callAccountType) => state.callAccountTypes.unshift(callAccountType.data),
    setCallAccountTypes: (state, callAccountTypes) => (state.callAccountTypes = callAccountTypes),
    updCallAccountType: (state, updatedCallAccountType) => {
      const index = state.callAccountTypes.findIndex(callAccountTypes => callAccountTypes.CallAccountTypeID === updatedCallAccountType.CallAccountTypeID);
      if (index !== -1) {
        state.callAccountTypes.splice(index, 1, updatedCallAccountType);
      }
    },
    dltCallAccountType: (state, CallAccountType) => {
      const index = state.callAccountTypes.findIndex(callAccountTypes => callAccountTypes.CallAccountTypeID === CallAccountType.CallAccountTypeID);
      if (index !== -1) {
        state.callAccountTypes.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // COUNTRIES

    newCountry: (state, country) => state.countries.unshift(country.data),
    setCountries: (state, countries) => (state.countries = countries),
    updCountry: (state, updatedCountry) => {
      const index = state.countries.findIndex(countries => countries.CountryId === updatedCountry.CountryId);
      if (index !== -1) {
        state.countries.splice(index, 1, updatedCountry);
      }
    },
    dltCountry: (state, Country) => {
      const index = state.countries.findIndex(countries => countries.CountryId === Country.CountryId);
      if (index !== -1) {
        state.countries.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CITIES

    newCity: (state, city) => state.cities.unshift(city.data),
    setCities: (state, cities) => (state.cities = cities),
    updCity: (state, updatedCity) => {
      const index = state.cities.findIndex(cities => cities.CityID === updatedCity.CityID);
      if (index !== -1) {
        state.cities.splice(index, 1, updatedCity);
      }
    },
    dltCity: (state, City) => {
      const index = state.cities.findIndex(cities => cities.CityID === City.CityID);
      if (index !== -1) {
        state.cities.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CLIENT TYPES

    newClientType: (state, clientType) => state.clientTypes.unshift(clientType.data),
    setClientTypes: (state, clientTypes) => (state.clientTypes = clientTypes),
    updClientType: (state, updatedClientType) => {
      const index = state.clientTypes.findIndex(clientTypes => clientTypes.ClientTypeID === updatedClientType.ClientTypeID);
      if (index !== -1) {
        state.clientTypes.splice(index, 1, updatedClientType);
      }
    },
    dltClientType: (state, ClientType) => {
      const index = state.clientTypes.findIndex(clientTypes => clientTypes.ClientTypeID === ClientType.ClientTypeID);
      if (index !== -1) {
        state.clientTypes.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CURRENCIES

    newCurrency: (state, currency) => state.currencies.unshift(currency.data),
    setCurrencies: (state, currencies) => (state.currencies = currencies),
    updCurrency: (state, updatedCurrency) => {
      const index = state.currencies.findIndex(currencies => currencies.CurrencyID === updatedCurrency.CurrencyID);
      if (index !== -1) {
        state.currencies.splice(index, 1, updatedCurrency);
      }
    },
    dltCurrency: (state, Currency) => {
      const index = state.currencies.findIndex(currencies => currencies.CurrencyID === Currency.CurrencyID);
      if (index !== -1) {
        state.currencies.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // DEALER GROUPS

    newDealerGroup: (state, dealerGroup) => state.dealerGroups.unshift(dealerGroup.data),
    setDealerGroups: (state, dealerGroups) => (state.dealerGroups = dealerGroups),
    updDealerGroup: (state, updatedDealerGroup) => {
      const index = state.dealerGroups.findIndex(dealerGroups => dealerGroups.DealerGroupID === updatedDealerGroup.DealerGroupID);
      if (index !== -1) {
        state.dealerGroups.splice(index, 1, updatedDealerGroup);
      }
    },
    dltDealerGroup: (state, DealerGroup) => {
      const index = state.dealerGroups.findIndex(dealerGroups => dealerGroups.DealerGroupID === DealerGroup.DealerGroupID);
      if (index !== -1) {
        state.dealerGroups.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // DELIVERY METHODS

    newDeliveryMethod: (state, deliveryMethod) => state.deliveryMethods.unshift(deliveryMethod.data),
    setDeliveryMethods: (state, deliveryMethods) => (state.deliveryMethods = deliveryMethods),
    updDeliveryMethod: (state, updatedDeliveryMethod) => {
      const index = state.deliveryMethods.findIndex(deliveryMethods => deliveryMethods.DeliveryMethodID === updatedDeliveryMethod.DeliveryMethodID);
      if (index !== -1) {
        state.deliveryMethods.splice(index, 1, updatedDeliveryMethod);
      }
    },
    dltDeliveryMethod: (state, DeliveryMethod) => {
      const index = state.deliveryMethods.findIndex(deliveryMethods => deliveryMethods.DeliveryMethodID === DeliveryMethod.DeliveryMethodID);
      if (index !== -1) {
        state.deliveryMethods.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // DEPOSIT METHODS

    newDepositMethod: (state, depositMethod) => state.depositMethods.unshift(depositMethod.data),
    setDepositMethods: (state, depositMethods) => (state.depositMethods = depositMethods),
    updDepositMethod: (state, updatedDepositMethod) => {
      const index = state.depositMethods.findIndex(depositMethods => depositMethods.DepositMethodID === updatedDepositMethod.DepositMethodID);
      if (index !== -1) {
        state.depositMethods.splice(index, 1, updatedDepositMethod);
      }
    },
    dltDepositMethod: (state, DepositMethod) => {
      const index = state.depositMethods.findIndex(depositMethods => depositMethods.DepositMethodID === DepositMethod.DepositMethodID);
      if (index !== -1) {
        state.depositMethods.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // FINANCIAL YEARS

    newFinancialYear: (state, financialYear) => state.financialYears.unshift(financialYear.data),
    setFinancialYears: (state, financialYears) => (state.financialYears = financialYears),
    updFinancialYear: (state, updatedFinancialYear) => {
      const index = state.financialYears.findIndex(financialYears => financialYears.FinancialYearID === updatedFinancialYear.FinancialYearID);
      if (index !== -1) {
        state.financialYears.splice(index, 1, updatedFinancialYear);
      }
    },
    dltFinancialYear: (state, FinancialYear) => {
      const index = state.financialYears.findIndex(financialYears => financialYears.FinancialYearID === FinancialYear.FinancialYearID);
      if (index !== -1) {
        state.financialYears.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // FREQUENCIES

    newFrequency: (state, frequency) => state.frequencies.unshift(frequency.data),
    setFrequencies: (state, frequencies) => (state.frequencies = frequencies),
    updFrequency: (state, updatedFrequency) => {
      const index = state.frequencies.findIndex(frequencies => frequencies.FrequencyID === updatedFrequency.FrequencyID);
      if (index !== -1) {
        state.frequencies.splice(index, 1, updatedFrequency);
      }
    },
    dltFrequency: (state, Frequency) => {
      const index = state.frequencies.findIndex(frequencies => frequencies.FrequencyID === Frequency.FrequencyID);
      if (index !== -1) {
        state.frequencies.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // HOLIDAYS

    newHoliday: (state, holiday) => state.holidays.unshift(holiday.data),
    setHolidays: (state, holidays) => (state.holidays = holidays),
    updHoliday: (state, updatedHoliday) => {
      const index = state.holidays.findIndex(holidays => holidays.HolidayID === updatedHoliday.HolidayID);
      if (index !== -1) {
        state.holidays.splice(index, 1, updatedHoliday);
      }
    },
    dltHoliday: (state, Holiday) => {
      const index = state.holidays.findIndex(holidays => holidays.HolidayID === Holiday.HolidayID);
      if (index !== -1) {
        state.holidays.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // IDENTITY TYPES

    newIdentityType: (state, identityType) => state.identityTypes.unshift(identityType.data),
    setIdentityTypes: (state, identityTypes) => (state.identityTypes = identityTypes),
    updIdentityType: (state, updatedIdentityType) => {
      const index = state.identityTypes.findIndex(identityTypes => identityTypes.IdentityTypeID === updatedIdentityType.IdentityTypeID);
      if (index !== -1) {
        state.identityTypes.splice(index, 1, updatedIdentityType);
      }
    },
    dltIdentityType: (state, IdentityType) => {
      const index = state.identityTypes.findIndex(identityTypes => identityTypes.IdentityTypeID === IdentityType.IdentityTypeID);
      if (index !== -1) {
        state.identityTypes.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // OVERRIDE REASONS

    newOverrideReason: (state, overrideReason) => state.overrideReasons.unshift(overrideReason.data),
    setOverrideReasons: (state, overrideReasons) => (state.overrideReasons = overrideReasons),
    updOverrideReason: (state, updatedOverrideReason) => {
      const index = state.overrideReasons.findIndex(overrideReasons => overrideReasons.OverrideReasonID === updatedOverrideReason.OverrideReasonID);
      if (index !== -1) {
        state.overrideReasons.splice(index, 1, updatedOverrideReason);
      }
    },
    dltOverrideReason: (state, OverrideReason) => {
      const index = state.overrideReasons.findIndex(overrideReasons => overrideReasons.OverrideReasonID === OverrideReason.OverrideReasonID);
      if (index !== -1) {
        state.overrideReasons.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // PROPERTY TYPES

    newPropertyType: (state, propertyType) => state.propertyTypes.unshift(propertyType.data),
    setPropertyTypes: (state, propertyTypes) => (state.propertyTypes = propertyTypes),
    updPropertyType: (state, updatedPropertyType) => {
      const index = state.propertyTypes.findIndex(propertyTypes => propertyTypes.PropertyTypeID === updatedPropertyType.PropertyTypeID);
      if (index !== -1) {
        state.propertyTypes.splice(index, 1, updatedPropertyType);
      }
    },
    dltPropertyType: (state, PropertyType) => {
      const index = state.propertyTypes.findIndex(propertyTypes => propertyTypes.PropertyTypeID === PropertyType.PropertyTypeID);
      if (index !== -1) {
        state.propertyTypes.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // REJECTION REASONS

    newRejectionReason: (state, rejectionReason) => state.rejectionReasons.unshift(rejectionReason.data),
    setRejectionReasons: (state, rejectionReasons) => (state.rejectionReasons = rejectionReasons),
    updRejectionReason: (state, updatedRejectionReason) => {
      const index = state.rejectionReasons.findIndex(rejectionReasons => rejectionReasons.RejectionReasonID === updatedRejectionReason.RejectionReasonID);
      if (index !== -1) {
        state.rejectionReasons.splice(index, 1, updatedRejectionReason);
      }
    },
    dltRejectionReason: (state, RejectionReason) => {
      const index = state.rejectionReasons.findIndex(rejectionReasons => rejectionReasons.RejectionReasonID === RejectionReason.RejectionReasonID);
      if (index !== -1) {
        state.rejectionReasons.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SECTORS

    newSector: (state, sector) => state.sectors.unshift(sector.data),
    setSectors: (state, sectors) => (state.sectors = sectors),
    updSector: (state, updatedSector) => {
      const index = state.sectors.findIndex(sectors => sectors.SectorID === updatedSector.SectorID);
      if (index !== -1) {
        state.sectors.splice(index, 1, updatedSector);
      }
    },
    dltSector: (state, Sector) => {
      const index = state.sectors.findIndex(sectors => sectors.SectorID === Sector.SectorID);
      if (index !== -1) {
        state.sectors.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ACCOUNT STATUSES

    newAccountStatus: (state, accountStatus) => state.accountStatuses.unshift(accountStatus.data),
    setAccountStatuses: (state, accountStatuses) => (state.accountStatuses = accountStatuses),
    updAccountStatus: (state, updatedAccountStatus) => {
      const index = state.accountStatuses.findIndex(accountStatuses => accountStatuses.AccountStatusID === updatedAccountStatus.AccountStatusID);
      if (index !== -1) {
        state.accountStatuses.splice(index, 1, updatedAccountStatus);
      }
    },
    dltAccountStatus: (state, AccountStatus) => {
      const index = state.accountStatuses.findIndex(accountStatuses => accountStatuses.AccountStatusID === AccountStatus.AccountStatusID);
      if (index !== -1) {
        state.accountStatuses.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // CUSTODIAN STATUSES

    newCustodianStatus: (state, custodianStatus) => state.custodianStatuses.unshift(custodianStatus.data),
    setCustodianStatuses: (state, custodianStatuses) => (state.custodianStatuses = custodianStatuses),
    updCustodianStatus: (state, updatedCustodianStatus) => {
      const index = state.custodianStatuses.findIndex(custodianStatuses => custodianStatuses.CustodianStatusID === updatedCustodianStatus.CustodianStatusID);
      if (index !== -1) {
        state.custodianStatuses.splice(index, 1, updatedCustodianStatus);
      }
    },
    dltCustodianStatus: (state, CustodianStatus) => {
      const index = state.custodianStatuses.findIndex(custodianStatuses => custodianStatuses.CustodianStatusID === CustodianStatus.CustodianStatusID);
      if (index !== -1) {
        state.custodianStatuses.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // PROPERTY STATUSES

    newPropertyStatus: (state, propertyStatus) => state.propertyStatuses.unshift(propertyStatus.data),
    setPropertyStatuses: (state, propertyStatuses) => (state.propertyStatuses = propertyStatuses),
    updPropertyStatus: (state, updatedPropertyStatus) => {
      const index = state.propertyStatuses.findIndex(propertyStatuses => propertyStatuses.PropertyStatusID === updatedPropertyStatus.PropertyStatusID);
      if (index !== -1) {
        state.propertyStatuses.splice(index, 1, updatedPropertyStatus);
      }
    },
    dltPropertyStatus: (state, PropertyStatus) => {
      const index = state.propertyStatuses.findIndex(propertyStatuses => propertyStatuses.PropertyStatusID === PropertyStatus.PropertyStatusID);
      if (index !== -1) {
        state.propertyStatuses.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // EXCHANGE PAIRS

    newExchangePair: (state, exchangePair) => state.exchangePairs.unshift(exchangePair.data),
    setExchangePairs: (state, exchangePairs) => (state.exchangePairs = exchangePairs),
    updExchangePair: (state, updatedExchangePair) => {
      const index = state.exchangePairs.findIndex(exchangePairs => exchangePairs.ExchangeID === updatedExchangePair.ExchangeID);
      if (index !== -1) {
        state.exchangePairs.splice(index, 1, updatedExchangePair);
      }
    },
    dltExchangePair: (state, ExchangePair) => {
      const index = state.exchangePairs.findIndex(exchangePairs => exchangePairs.ExchangeID === ExchangePair.ExchangeID);
      if (index !== -1) {
        state.exchangePairs.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // TITLES

    newTitle: (state, title) => state.titles.unshift(title.data),
    setTitles: (state, titles) => (state.titles = titles),
    updTitle: (state, updatedTitle) => {
      const index = state.titles.findIndex(titles => titles.TitleID === updatedTitle.TitleID);
      if (index !== -1) {
        state.titles.splice(index, 1, updatedTitle);
      }
    },
    dltTitle: (state, Title) => {
      const index = state.titles.findIndex(titles => titles.TitleID === Title.TitleID);
      if (index !== -1) {
        state.titles.splice(index, 1);
      }
    },

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // TRANSACTION CODES

    newTransactionCode: (state, transactionCode) => state.transactionCodes.unshift(transactionCode.data),
    setTransactionCodes: (state, transactionCodes) => (state.transactionCodes = transactionCodes),
    updTransactionCode: (state, updatedTransactionCode) => {
      const index = state.transactionCodes.findIndex(transactionCodes => transactionCodes.TransactionCodeID === updatedTransactionCode.TransactionCodeID);
      if (index !== -1) {
        state.transactionCodes.splice(index, 1, updatedTransactionCode);
      }
    },
    dltTransactionCode: (state, TransactionCode) => {
      const index = state.transactionCodes.findIndex(transactionCodes => transactionCodes.TransactionCodeID === TransactionCode.TransactionCodeID);
      if (index !== -1) {
        state.transactionCodes.splice(index, 1);
      }
    },
  },
}
